import { type SearchContent } from '@databases/connections/types';
import { type PageReference } from '@databases/types/confluence';
import { createContentARI } from '@databases/utils/ariHelper';

// Keep this local to avoid making @databases/content-picker depend on @databases/fields.
export type ExtendedPageReference = PageReference<{
  metadata?: {
    lastModified: string;
    spaceName: string;
  };
  contentId: string;
}>;

export const processSearchContentData = (
  data: SearchContent[]
): ExtendedPageReference[] => {
  return data.map(
    (result) =>
      ({
        type: result.content.type,
        spaceKey: result.container.displayUrl.split('/spaces/')[1],
        contentTitle: result.title,
        contentId: result.content.id,
        ari: createContentARI(result.content.type, result.content.id),
        metadata: {
          lastModified: result.lastModified,
          spaceName: result.container.title
        }
      }) as ExtendedPageReference
  );
};
